import { render, staticRenderFns } from "./ProductionLicenses.vue?vue&type=template&id=5d62b6a4&scoped=true"
import script from "./ProductionLicenses.vue?vue&type=script&lang=js"
export * from "./ProductionLicenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d62b6a4",
  null
  
)

export default component.exports